
import dialogCloseBtn from "../common/dialog-close-btn.vue";
import openNewAccountImage from "~/assets/images/open-new-account.svg";
import openLogo from "~/assets/images/open-logo.svg";
export default {
  components: {
    dialogCloseBtn
  },
  props: {
    showBankingInfoDialog: Boolean
  },
  data() {
    return {
      openNewAccountImage,
      openLogo,
      valid: false,
      accountHolder: "",
      accountNumber: "",
      ifscCode: "",
      bankName: "",
      accountRule: [
        (v) => !!v || "Account Number is required",
        (v) => /^[0-9]{9,18}$/.test(v) || "Account number is not valid"
      ],
      ifscRule: [
        (v) => !!v || "IFSC Code is required",
        (v) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(v) || "IFSC Code is not valid"
      ],
      selectRule: [(v) => !!v || "Please select a bank"],

      banks: [
        { id: 1, name: "State Bank of India" },
        { id: 2, name: "Union Bank of India" },
        { id: 3, name: "Canara Bank" },
        { id: 4, name: "Axis Bank" },
        { id: 5, name: "HDFC Bank" },
        { id: 6, name: "Federal Bank" }
      ]
    };
  },
  methods: {
    submitBankInfo() {
      if (this.$refs.formBankInfo.validate()) {
        const data = {
          nextStep: "ACCOUNT_ADDED",
          formData: {
            accountHolder: this.accountHolder,
            accountNumber: this.accountNumber,
            ifscCode: this.ifscCode,
            bankName: this.bankName
          }
        };

        this.$emit("show-next-step", data);
      }
    }
  }
};
